<template>
	<span>
		<b-nav v-if="showNav">
			<b-nav-item-dropdown id="my-nav-dropdown " text="Troubleshooting" toggle-class="nav-link-custom">
				<template slot="button-content">
					<i class="fa mr-2 fa-tools text-indigo" font-scale="1"></i>
					<span>Troubleshooting</span>
				</template>

				<slot v-for="(item, index) in links" name="title">
					<b-dropdown-item 
						v-if="item.attr_type === 'internal'"
						:key="index"
						:to="item.link" 
						:title="item.description" 
						b-v-tooltip.hover
					>
						<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
						{{ item.name }}
					</b-dropdown-item>
					<b-dropdown-item 
						v-else-if="item.attr_type === 'external_iframe'"
						:key="index+'iframe'"
						:to="`/iframe/:?src=${item.link}`"
						:title="item.description"
						b-v-tooltip.hover
					>
						<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
						{{ item.name }}
					</b-dropdown-item>
					<b-dropdown-item 
						v-else
						:key="item.id"
						:href="item.link"
						target="_blank" 
						:title="item.description" 
						b-v-tooltip.hover
					>
						<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
						{{ item.name }}
					</b-dropdown-item>
				</slot>
			</b-nav-item-dropdown>
		</b-nav>
	</span>
</template>
<script>
export default {
	name: "top-trouble-dynamic-group",
	computed: {
		links() {
			return this.$store.getters["getLinksByGroup"]("Troubleshooting");
		},
		showNav() {
			return this.$store.getters["getLinksByGroup"]("Troubleshooting").length > 0;
		},
	},
};
</script>
